import React, { useState, useRef, useEffect } from 'react';
import styles from 'feature/common/landing/start/index.module.scss';
import { useTranslation } from 'react-i18next';
import className from 'classnames/bind';
import { Button } from 'mochi-react-component';
import { devicePlateForm } from 'utils/device-util';
import amplitudeService from 'service/amplitude';
import ReactPixel from 'react-facebook-pixel';
import useIntersect from 'utils/intersect-helper';

const importAll = r => {
  return r.keys().map(r);
};
const images = importAll(require.context('images/landing', false, /partner/));
const cx = className.bind(styles);

const Start = () => {
  const { t } = useTranslation();
  const startRef = useRef();
  const [contentShow, setContentShow] = useState(false);
  const [partnersShow, setPartnersShow] = useState(false);

  const [setElement] = useIntersect(() => {
    setTimeout(() => {
      setContentShow(true);
    }, 0);
    setTimeout(() => {
      setPartnersShow(true);
    }, 500);
    ReactPixel.track('ViewContent', {
      content_name: 'start',
    });
  });

  useEffect(() => {
    setElement([startRef.current]);
  }, [setElement]);

  const contentClass = cx({
    content: true,
    show: contentShow,
  });

  const partnersClass = cx({
    partners: true,
    show: partnersShow,
  });
  const partner = () => {
    return images.map((img, index) => {
      return <img key={index} src={img.default} alt={`partner${index}`} loading="lazy" />;
    });
  };

  const fontSize = () => {
    return devicePlateForm() === 'desktop' ? `14px` : `12px`;
  };

  return (
    <section className={styles.start} ref={startRef}>
      <h2>{t('landing.start.title')}</h2>
      <div className={contentClass}>
        <h3>{t('landing.start.message')}</h3>
        <div className={styles.more}>
          <a href="https://newsroom.autopass.xyz/company-info/">
            <Button
              type="solid"
              theme="black"
              onClick={() => {
                ReactPixel.track('getInfo', {});
                amplitudeService.track('服務介紹頁-了解更多_點擊');
              }}
              customStyle={{ fontSize: fontSize() }}
            >
              {t('landing.start.read_more')}
            </Button>
          </a>
          <a href="mailto:bd@pklotcorp.com">
            <Button
              type="solid"
              theme="black"
              onClick={() => {
                amplitudeService.track('服務介紹頁-聯繫我們_點擊');
              }}
              customStyle={{ fontSize: fontSize() }}
            >
              {t('landing.start.contact_us')}
            </Button>
          </a>
        </div>
      </div>
      <div className={partnersClass}>{partner()}</div>
    </section>
  );
};

export default Start;
